<script lang="ts">
    
    import { getContext } from "svelte";
    import type { Fn } from "../global";

    const registerSlide: Fn = getContext('registerSlide');
    const unregisterSlide: Fn = getContext('unregisterSlide');

    export let value: any = null;

    function handleSlide(slideEl: HTMLElement) {
        registerSlide(slideEl, () => value);
        return {
            destroy() {
                unregisterSlide(slideEl);
            }
        };
    }

</script>

<style lang="scss">

    .swiper-slide {
        text-align: center;
    }

</style>

<div class="swiper-slide" use:handleSlide>
    <slot>{value}</slot>
</div>
